<header class="flex h-16 items-center border-b bg-white px-4">
  <div class="flex items-center">
    <img alt="Norupe Logo" src="assets/logo.svg" />
  </div>

  <nav class="ml-4 hidden h-full md:flex">
    <ul class="flex h-full items-center gap-0.5">
      @for (item of navigation; track $index) {
        <li
          *hasRole="item.roles"
          routerLinkActive="border-t border-red-600"
          class="flex h-full items-center bg-white hover:cursor-pointer hover:brightness-90"
        >
          <a class="flex h-full w-full items-center px-2" [routerLink]="item.route">
            {{ item.label }}
          </a>
        </li>
      }
    </ul>
  </nav>

  <div class="ml-auto hidden gap-2 md:flex">
    @if (profileSrv.isAuthenticated()) {
      <p>{{ profileSrv.profile()?.first_name }}</p>
      <button type="button" class="flex gap-2 justify-self-end hover:cursor-pointer" (click)="profileSrv.logout()">
        <mat-icon> logout </mat-icon>
      </button>
    }
  </div>

  <button
    type="button"
    class="ml-auto flex items-center rounded-md p-2.5 text-gray-700 hover:cursor-pointer hover:bg-gray-100 md:hidden"
    [class.hidden]="dialogOpen"
    (click)="toggleDialog()"
  >
    <mat-icon> menu </mat-icon>
  </button>

  <div role="dialog" class="md:hidden" aria-modal="true">
    <div
      class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
      [class.hidden]="!dialogOpen"
    >
      <button
        type="button"
        class="fixed top-3 right-3 flex items-center rounded-md p-2.5 text-gray-700 hover:cursor-pointer hover:bg-gray-100"
        (click)="toggleDialog()"
      >
        <mat-icon> close </mat-icon>
      </button>
      <div class="mt-14 flow-root">
        <div class="-my-6 divide-y divide-gray-500/10">
          <div class="m-2 flex gap-2">
            @if (profileSrv.isAuthenticated()) {
              <mat-icon> person</mat-icon>
              <p>{{ profileSrv.profile()?.first_name ?? "" }}</p>
            }
          </div>
          <ul class="flex h-full w-full flex-col gap-0.5">
            @for (item of navigation; track $index) {
              <li
                routerLinkActive="border-b border-red-600 "
                class="flex h-full w-full rounded-xs bg-white py-2 hover:cursor-pointer hover:brightness-90"
              >
                <a class="flex h-full w-full pl-2" [routerLink]="item.route">
                  {{ item.label }}
                </a>
              </li>
            }
          </ul>

          @if (profileSrv.isAuthenticated()) {
            <button type="button" class="mt-4 flex gap-2 pl-2 hover:cursor-pointer" (click)="profileSrv.logout()">
              Iziet
              <mat-icon> logout </mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</header>
